import { useEffect } from 'react'
import { loadImage } from 'src/utils'

export const useLoadImage = (images) => {
  useEffect(() => {
    images?.forEach((image) => {
      loadImage(image)
    })
  }, [])
}
